import {Component} from "@angular/core";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {OrderService} from "./order.service";
import {DeviceOrderSplitResultModel} from "./order.gql-model";
import {handleErrors} from "../misc/handle-errors.decorator";

export interface DeviceQuantityInterface {
  deviceId?: string;
  splitId?: string;
  siteOrderId?: string;
  totalQuantity?: number;
}

export type SplitResultItem = {
  splitId?: string;
  quantity?: number;
  orderNumber?: any;
  orderDate?: any;
};

@Component({
  templateUrl: "./split-device-quantity-dialog.template.pug",
  providers: [OrderService],
})
export class SplitDeviceQuantityDialogComponent
  extends DialogComponent<DeviceQuantityInterface, DeviceOrderSplitResultModel[]>
  implements DeviceQuantityInterface {
  deviceId: string;
  splitId: string;
  siteOrderId: string;
  totalQuantity: number;
  splitQuantity: number = 0;
  error: Error;

  static show(dialogService: DialogService, data: DeviceQuantityInterface): Promise<DeviceOrderSplitResultModel[]> {
    return dialogService.showDialog(SplitDeviceQuantityDialogComponent, data);
  }

  constructor(public dialogService: DialogService, private orderService: OrderService) {
    super(dialogService);
    this.result = [];
  }

  @handleErrors()
  async save() {
    this.result = await this.orderService.splitDevice(
      this.deviceId,
      this.splitId,
      this.siteOrderId,
      [
        (+this.totalQuantity - +this.splitQuantity).toString(10),
        (+this.splitQuantity).toString(10),
      ],
    );

    this.close();
  }
}
